import { Component, OnDestroy, OnInit } from "@angular/core";
import { AuthorP, PostContentP, PostP } from "../../../data/blog-client-api";
import { Subscription } from "rxjs";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { SeoService } from "../../../data/seo/seo-service.service";
import { Location } from "@angular/common";

declare var videojs: any;
declare var $: any;

@Component({
  selector: "app-blog-content",
  templateUrl: "./blog-content.component.html",
  styleUrls: ["./blog-content.component.css"],
})
export class BlogContentComponent implements OnInit, OnDestroy {
  blogId: number;
  contentId: number;
  blog: PostP;
  blogContents: PostContentP[] = [];
  selectedBlogContent: PostContentP = {};
  authorBlogGroup: AuthorP = {
    id: -1,
    name: "Author",
    contents: [],
    about: "about",
  };
  player: any;
  pageUrl: string;
  isPlay: boolean = false;
  isDesktop: boolean;
  isMobile: boolean;
  routerSub: Subscription;
  navUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogService: BlogDataRestService,
    private location: Location,
    private deviceService: DeviceDetectorService,
    private seoService: SeoService
  ) {
    this.isDesktop = deviceService.isDesktop();
    this.isMobile = deviceService.isMobile();
  }

  ngOnInit() {
    this.blogId = +this.route.snapshot.paramMap.get("blogId");
    this.contentId = +this.route.snapshot.paramMap.get("id");
    this.getBlogContents();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
        this.blogId = +this.route.snapshot.paramMap.get("blogId");
        this.contentId = +this.route.snapshot.paramMap.get("id");
        this.getBlogContents();
      }
    });

    $(document).ready(function () {
      $(".blog-detail-container").scroll(function () {
        if ($(this).scrollTop() > 20) {
          $(".blog-player-container").addClass("transitionOnTop");
          $(".blog-detail-container").addClass("detailTransition");
          $(".blog-detail-description-box").addClass("descriptionMaxHeight");
        } else {
          $(".blog-player-container").removeClass("transitionOnTop");
          $(".blog-detail-container").removeClass("detailTransition");
          $(".blog-detail-description-box").removeClass("descriptionMaxHeight");
        }
      });
      $(".content").addClass("contentSetWidth");
    });
  }
  ngOnDestroy() {
    if (!!this.player) {
      this.player.dispose();
    }
    $(".content").removeClass("contentSetWidth");
  }

  getBlogContents() {
    this.blogService.getBlogById(this.blogId).subscribe((data) => {
      this.blog = data;
      this.blogContents = this.blog.postContents;
      this.selectedBlogContent =
        this.blog.postContents[
          this.blog.postContents.findIndex((item) => item.id == this.contentId)
        ];

      this.initPlayer();
      this.setSeoInfos();
      this.getAuthorBlogs(this.selectedBlogContent);
    });
  }

  nextButton: HTMLElement;
  prevButton: HTMLElement;
  initPlayer() {
    if (!this.player) {
      this.player = videojs("content-audio-player", {
        controls: true,
        fluid: false,
        controlBar: {
          playToggle: {
            replay: true,
          },
        },
      });
      ///////////////////////////////////////////////////////////////////////////
      let controlBarEl = this.player.getChild("controlBar").el();

      let nextButtonEl = document.createElement("div");
      nextButtonEl.classList.add("next-button-container");
      nextButtonEl.setAttribute("id", "next-button-container");
      nextButtonEl.innerHTML =
        '<i class="fa fa-step-forward" aria-hidden="true"></i>';
      controlBarEl.insertBefore(nextButtonEl, controlBarEl.childNodes[1]);

      let prevButtonEl = document.createElement("div");
      prevButtonEl.classList.add("prev-button-container");
      prevButtonEl.setAttribute("id", "prev-button-container");
      prevButtonEl.innerHTML =
        '<i class="fa fa-step-backward" aria-hidden="true"></i>';
      controlBarEl.insertBefore(prevButtonEl, controlBarEl.childNodes[0]);

      setTimeout(() => {
        this.nextButton = document.getElementById("next-button-container");
        this.prevButton = document.getElementById("prev-button-container");

        this.nextButton.addEventListener("click", () => {
          let index = this.blog.postContents.findIndex(
            (item) => item.id == this.selectedBlogContent.id
          );
          if (this.blog.postContents.length - 1 > index) {
            this.player.src([
              { type: "audio/mp3", src: this.blogContents[index + 1].mediaUrl },
            ]);
            this.selectedBlogContent = this.blogContents[index + 1];
            this.router.navigate([
              "/blog/" +
                this.blogId +
                "/content/" +
                this.selectedBlogContent.id,
            ]);
          }
        });

        this.prevButton.addEventListener("click", (event) => {
          let index = this.blog.postContents.findIndex(
            (item) => item.id == this.selectedBlogContent.id
          );
          if (0 < index) {
            this.player.src([
              { type: "audio/mp3", src: this.blogContents[index - 1].mediaUrl },
            ]);
            this.selectedBlogContent = this.blogContents[index - 1];
            this.router.navigate([
              "/blog/" +
                this.blogId +
                "/content/" +
                this.selectedBlogContent.id,
            ]);
          }
        });
      }, 100);

      ///////////////////////////////////////////////////////////////////////////
    }

    this.player.src([
      { type: "audio/mp3", src: this.selectedBlogContent.mediaUrl },
    ]);

    this.player.on("playing", () => {
      this.isPlay = true;
    });

    this.player.on("pause", () => {
      this.isPlay = false;
    });

    this.player.on("loadedmetadata", () => {
      if (this.isPlay) {
        this.player.play();
      }
    });

    this.player.on("error", (e: any) => {
      console.log("player", e); //error
    });

    var thiz = this;

    $(document).keyup(function (e: any) {
      if (e.which === 37 && thiz.player) {
        //key press left arrow
        thiz.player.currentTime(thiz.player.currentTime() - 10);
      }

      if (e.which === 39 && thiz.player) {
        //key press right arrow
        thiz.player.currentTime(thiz.player.currentTime() + 10);
      }
    });
  }

  setSeoInfos() {
    this.seoService.generateTags({
      title: this.selectedBlogContent.title,
      description: this.selectedBlogContent.description,
      image: this.blog.posterUrl,
      slug: "blog/" + this.blogId + "/content/" + this.contentId,
      url: this.router.url,
    });
  }

  getAuthorBlogs(content: PostContentP) {
    this.blogService.getBlogsByAuthor(content.author.id).subscribe((data) => {
      if (data.contents.length) {
        let index = data.contents.findIndex((item) => item.id == content.id);
        if (index > -1) {
          data.contents.splice(index, 1);
        }
      }
      this.authorBlogGroup = data;
    });
  }

  locationBack() {
    if (
      !!sessionStorage.getItem("urlhistory") &&
      JSON.parse(sessionStorage.getItem("urlhistory")).length < 2
    ) {
      this.router.navigateByUrl("dashboard/-2/blog");
    } else {
      this.location.back();
    }
  }

  changeContent(content: PostContentP) {
    this.scrollToTop();
    if (this.blogId === content.posts[0].id) {
      this.selectedBlogContent =
        this.blogContents[
          this.blogContents.findIndex((item) => item.id == content.id)
        ];
      this.router.navigate([
        "/blog/" + content.posts[0].id + "/content/" + content.id,
      ]);
      return;
    }

    this.blogId = content.posts[0].id;
    this.contentId = content.id;
    this.router.navigate([
      "/blog/" + content.posts[0].id + "/content/" + content.id,
    ]);
  }

  scrollToTop() {
    $(".blog-detail-container").animate({ scrollTop: 0 });
    $(".blog-detail-paragraph").animate({ scrollTop: 0 });
    $(".blog-other-articles-container").animate({ scrollTop: 0 });
  }

  public share(type:string) {
    let location = window.location.href;
    switch(type) {
      case 'facebook':
        this.navUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + location;
        break;
      case 'twitter':
        this.navUrl =  'https://twitter.com/share?url=' + location;
        break;
        case 'linkedin':
          this.navUrl =  'https://www.linkedin.com/sharing/share-offsite/?url=' +  location;
    }
    return window.open(this.navUrl, "_blank");
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/blog/blog-content/blog-content.component.ts